import type { SpaceActions, WorkspaceStoreStateType } from "./index";
import { WorkspaceActionType } from "./index";

export type WorkspaceReducer = (
  state: WorkspaceStoreStateType,
  action: SpaceActions,
) => WorkspaceStoreStateType;

export const workspaceReducer: WorkspaceReducer = (state, action) => {
  switch (action.type) {
    case WorkspaceActionType.SetSpaceId: {
      return {
        ...state,
        spaceId: action.payload,
      };
    }
    default:
      return state;
  }
};
